'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { importQueueHideCompletedStorageKey } from '../constants/import-queue-preference-storage-keys';
function readStored(domainKey: string): boolean {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(importQueueHideCompletedStorageKey(domainKey)) === 'true';
}
export function useImportQueueHideCompleted(domainKey) {
  const $ = _c(8);
  const [hideCompleted, setHideCompletedState] = useState(false);
  let t0;
  let t1;
  if ($[0] !== domainKey) {
    t0 = () => {
      setHideCompletedState(readStored(domainKey));
    };
    t1 = [domainKey];
    $[0] = domainKey;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== domainKey) {
    t2 = value => {
      setHideCompletedState(value);
      window.localStorage.setItem(importQueueHideCompletedStorageKey(domainKey), String(value));
    };
    $[3] = domainKey;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const setHideCompleted = t2;
  let t3;
  if ($[5] !== hideCompleted || $[6] !== setHideCompleted) {
    t3 = {
      hideCompleted,
      setHideCompleted
    };
    $[5] = hideCompleted;
    $[6] = setHideCompleted;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}